import React, { useCallback, useEffect, useState } from 'react';
import { BarChart3, RefreshCw, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/api';
import { Button } from '../../components/ui/button';
import { HomeSmartEconomicsSummary } from '../../components/home-smart/HomeSmartEconomicsSummary';

const now = new Date();
const today = now.toISOString().slice(0, 10);
const firstDay = `${today.slice(0, 7)}-01`;

export default function HomeSmartEconomicsPage() {
  const [dateFrom, setDateFrom] = useState(firstDay);
  const [dateTo, setDateTo] = useState(today);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!dateFrom || !dateTo || dateFrom > dateTo) return;
    setLoading(true);
    try {
      const params = new URLSearchParams({ date_from: dateFrom, date_to: dateTo });
      const response = await api.get(`/admin/home-smart/economics?${params}`);
      setData(response.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Contatori Home Smart non disponibili');
    } finally {
      setLoading(false);
    }
  }, [dateFrom, dateTo]);

  useEffect(() => { load(); }, [load]);

  return <main className="min-h-screen bg-slate-50 p-3 sm:p-5 lg:p-6" data-testid="home-smart-economics-page">
    <div className="mx-auto max-w-[1600px] space-y-5">
      <header className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div><div className="flex items-center gap-2 text-xs font-bold uppercase text-emerald-700" data-testid="home-smart-admin-only-label"><ShieldCheck className="h-4 w-4" />Solo amministratori</div><h1 className="mt-1 text-3xl font-bold text-slate-950" data-testid="home-smart-economics-title">Ricavi Home Smart</h1><p className="mt-2 max-w-3xl text-sm text-slate-600" data-testid="home-smart-economics-description">Contatori separati per riconciliare incassi, IVA, commissioni, consumi, credito residuo e contributo diretto senza creare un nuovo conto PayPal.</p></div>
        <div className="flex flex-wrap items-end gap-2 rounded-md border border-slate-300 bg-white p-3" data-testid="home-smart-period-controls"><label className="text-xs font-semibold text-slate-600">Dal<input type="date" value={dateFrom} max={dateTo} onChange={(event) => setDateFrom(event.target.value)} className="mt-1 block h-9 rounded-md border px-2 text-sm" data-testid="home-smart-date-from" /></label><label className="text-xs font-semibold text-slate-600">Al<input type="date" value={dateTo} min={dateFrom} onChange={(event) => setDateTo(event.target.value)} className="mt-1 block h-9 rounded-md border px-2 text-sm" data-testid="home-smart-date-to" /></label><Button onClick={load} disabled={loading || !dateFrom || !dateTo || dateFrom > dateTo} data-testid="home-smart-economics-refresh"><RefreshCw className={`mr-2 h-4 w-4 ${loading ? 'animate-spin' : ''}`} />Aggiorna</Button></div>
      </header>
      <div className="border-l-4 border-blue-600 bg-blue-50 p-4 text-sm text-blue-950" data-testid="home-smart-accounting-note"><BarChart3 className="mr-2 inline h-4 w-4" />Il credito venduto diventa ricavo maturato quando viene utilizzato per un invio. Il contributo diretto non comprende ancora i costi generali aziendali.</div>
      {loading && !data ? <div className="py-20 text-center text-slate-500" data-testid="home-smart-economics-loading">Caricamento contatori…</div> : <HomeSmartEconomicsSummary data={data} />}
    </div>
  </main>;
}